var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.finalViewBox,"fill":_vm.fill,"stroke":_vm.stroke}},[_c(_vm.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }